@import "../../global/gx-ide-common";

:host(.breadcrumb) {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--spacing-gap-xs);
  margin: 0;
  padding-block: var(--spacing-padding-xs);
  padding-inline: 0;
  list-style: none;
}

.list {
  display: contents;
}

.list-item {
  display: inline-flex;
  align-items: center;
  gap: var(--spacing-gap-xs);
  list-style: none;
}

.separator {
  color: var(--color-text-neutral-subtle);
  padding-inline: var(--spacing-padding-xs);
  user-select: none;
  pointer-events: none;
  opacity: 0.85;
}
